// extracted by mini-css-extract-plugin
export var body = "_om-8";
export var button = "_om-0";
export var closeButton = "_om-5";
export var content = "_om-3";
export var empty = "_om-f";
export var grid = "_om-c";
export var header = "_om-4";
export var icon = "_om-1";
export var option = "_om-d";
export var optionSelected = "_om-e";
export var overlay = "_om-2";
export var searchIcon = "_om-a";
export var searchInput = "_om-b";
export var searchWrapper = "_om-9";
export var title = "_om-6";
export var visuallyHidden = "_om-7";